import { apiClient } from './api';
import type { CoursesResponse } from '../types/teachable';

interface ApiResponse<T> {
  data: T;
  meta: Record<string, unknown>;
  status: string;
}

export const teachableService = {
  /**
   * Get enrolled + unclaimed courses
   * GET /api/teachable/courses/
   */
  async getCourses(): Promise<CoursesResponse> {
    const response = await apiClient.get<ApiResponse<CoursesResponse>>('/api/teachable/courses/');
    return response.data;
  },

  /**
   * Claim a pending course enrollment by ID
   * POST /api/teachable/courses/{enrollmentId}/claim/
   */
  async claimCourse(enrollmentId: number): Promise<void> {
    await apiClient.post(`/api/teachable/courses/${enrollmentId}/claim/`, {});
  },
};
